export const API_URL = process.env.REACT_APP_API_URL;
export const appClient = process.env.REACT_APP_CLIENT;

export const COLORS = {
    blue: '#4285f4',
    red: '#ea4236',
    yellow: '#fcbc00',
    gray: '#A5A5A5',
    green: '#34a754',
    orange: '#ff6d01',
    turquoise: '#46bec6',
    lightBlue: '#7ba9f7',
    pavesiMain: '#699418',
    attentamenteMain: '#002f87',
    networkMain: '#ad3f10',
    wiaMain: '#a8a29e',
    libriMain: '#002f87',
    unipolisMain: '#002a4f',
    cdpMain: '#405464',
    e4ImpactMain: '#009d6f',
    e4ImpactBlue: '#5b9bd5',
    e4ImpactOrange: '#ed7d32',
    feba: '#006538',
    fdcMilano: '#f97316',
    fsv: '#e11d48',
    fsv2024: '#2dd4bf',
    fsv2025: '#7c3aed',
    fdc: '#a16207',
    zeroNeet: '#0f766e',
};
export const EXPORTING = {
    buttons: {
        contextButton: {
            menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadSVG',
            ],
        },
    },
};
